import CloseIcon from '@mui/icons-material/Close';
import {
    AppBar,
    Box,
   
    Card,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid2,
    IconButton,

    Slide,
    Toolbar,
    Typography,
    useTheme
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React, { FC, forwardRef, useEffect, useMemo, useState } from 'react';
import { SearchInput } from '../../../Form/InputSearch/input-search.component';
import { ListProductUseCase } from '../../../../Usecase/Products/list-product-usecase';
import { useToast } from '../../../../Hooks/ToasContext';
import { IProductEntity } from '../../../../Services/api/products/products.interface';
import { Table } from '../../../Table/table.component';
import { Environment } from '../../../../Config/constants';
import { ICreateRulesPoliciesPayload, IPricePoliciesEntity, IPricePoliciesRulesEntity, IUpdateRulesPoliciesPayload } from '../../../../Services/api/price-policies/price-policies.interface';
import { SubmitHandler, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { IProductProps } from '../../../../Pages/Products/Form/create-products-hook';
import { Input } from '../../../Form/Input/input.component';
import { Button } from '../../../Form/Button/button.scomponent';

interface IAddPricePolicyVariantProps {
    data?: IPricePoliciesRulesEntity
    onClose: () => void
    onSubmit: (data: ICreateRulesPoliciesPayload) => Promise<void>
    policyId: string
    
}

interface IRulePricePolicies {
  minQuantity: number
  discountPercentage: number
}


const RulePricePoliciesSchemaValidation = Yup.object().shape({
  minQuantity: Yup.number().required('Quantidade mínima é obrigatória'),
  discountPercentage: Yup.number().required('Desconto é obrigatório'),
 
});



const AddPricePolicyVariant : FC<IAddPricePolicyVariantProps> = ({ data, onClose, onSubmit, policyId }) => {

    const [loading, setLoading] = useState(false)
    const [products, setProducts] = useState<IProductEntity[]>([])
    const { showToast } = useToast()

    const { handleSubmit, register, control, formState, watch, setValue, unregister, getValues } = useForm<IRulePricePolicies>({
      resolver: yupResolver(RulePricePoliciesSchemaValidation),
      defaultValues: {
        minQuantity: data?.minimalQuantity || 0,
        discountPercentage: data?.discountPercentage || 0
      }
    });

    const handleAction: SubmitHandler<IRulePricePolicies> = async (values) => {
      
      try {
          setLoading(true)

          const payload : ICreateRulesPoliciesPayload | IUpdateRulesPoliciesPayload= {
            minimalQuantity: values.minQuantity,
            discountPercentage: values.discountPercentage,
            description: 'no-description',
            policyId,
            ruleId: data?.id || ''
          }

          await onSubmit(payload)

     
           
      } catch (error) {
        console.log("error: ", error)
          // toast({
          //   position: 'top-right',
          //   render: () => <ToastCustom type='fail' title='Erro' description={error.response?.data?.error ?? 'Erro ao logar. Por favor, tente novamente'} />,
          // });
      } finally {
          setLoading(false);
      }
    };


  
  

  return (
    <>
      <Dialog
        open
        // TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            padding: '15px'
          }
        }}
      >
        <DialogTitle>Regra - Política de Preço</DialogTitle>
        <DialogContent>
          <Grid2 container spacing={2} sx={{ marginTop: 2}} component="form" onSubmit={handleSubmit(handleAction)} id="add-price-policy-variant-form">
         
          
                <Grid2 size={3}>
                  <Input
                    label="Quantidade mínima"
                    type="number"
                    placeholder="Ex: 1000"
                    {...register('minQuantity')}
                  
                  
             
                  />
                </Grid2>
                <Grid2 size={3}>
                  <Input
                    label="Desconto (%)"
                    type="number"
                    placeholder="Ex: 5"
                    value={watch('discountPercentage')}
                    {...register('discountPercentage')}
                   
             
                  />
                </Grid2>
                <Grid2 size={6}>
                  <Typography variant="body2" sx={{ color: '#666' }}>
                    Se quantidade ≥ {watch('minQuantity') || 0}, aplicar {watch('discountPercentage') || 0}% de desconto
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#999', display: 'block', marginTop: '5px' }}>
                    Preço final: {((100 - (watch('discountPercentage') || 0)) / 100).toFixed(2)}x o preço original
                  </Typography>
                </Grid2>
                {/* <Grid2 size={1}>
                  <IconButton 
                    onClick={() => onClose()}
                    color="error"
                    sx={{ marginTop: '10px' }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Grid2> */}
          </Grid2>
            


        </DialogContent>
        <DialogActions>
          <Button type="submit" sx={{ marginTop: '10px', width: '200px' }} isLoading={loading} form="add-price-policy-variant-form">
            SALVAR
          </Button>
          <Button onClick={onClose} sx={{ marginTop: '10px', width: '200px' }} variant='text'>Cancelar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddPricePolicyVariant;
